import ScribbleClient from "./generated/client";
export default ScribbleClient;
